import { CircularProgress, Fade } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
    width: "100%",
    minHeight: 100,
    display:'flex',
    flexDirection:'column',
    alignItems:'stretch',
    '&>*':{
      flexGrow:1
    },
    maxHeight:"100vh"
  },
  loader: {
    position: "absolute",
    height: "100%",
    width: "100%",
    top: "0px",
    left: "0px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    background: "rgba(255, 255, 255, 0.5)",
    zIndex: 10,
    borderRadius: theme.shape.borderRadius,
  },
}));

const LoaderView = (props) => {
  const classes = useStyles();
  const { loading, children } = props;
  return (
    <div className={classes.root}>
      {children}
      <Fade in={loading} unmountOnExit>
        <div className={classes.loader}>
          <CircularProgress color="primary" />
        </div>
      </Fade>
    </div>
  );
};

LoaderView.propTypes = {
  children: PropTypes.element,
  loading: PropTypes.any,
};

export default LoaderView;
